<bb-page-header 
	[icon]="'film'" 
	[title]="'MEDIACLIPS' | translate" 
	[allowCustomPreset]="allowCustomPreset"
	[filterConfig]="filterConfig"
	[currentPath]="listConfiguration.activePath">
</bb-page-header>

<div class="body-column">

	<a class="button" [routerLink]="['/library/mediaclip/new', 'metadata']"><i class="fa fa-plus"></i>
		<span>{{ 'CREATE_NEW' | translate }}</span>
	</a>

	<span
	class="use-common-clip-toggle"
	[hasPermission]="'creative_management'">
		<label><bb-check [(ngModel)]="useCommonClip" name="useCommonClip"></bb-check> {{'SHOW_CREATIVES' | translate }}</label>
	</span>

	<div class="with-selected">
		<span class="selected-label" [hidden]="selectedRows.length">{{ 'NO_MEDIA_CLIPS_SELECTED' | translate }}</span>
		<span class="selected-label" [hidden]="!selectedRows.length">
			{{ 'WITH_SELECTED' | translate : {value: selectedRows.length} }}:
		</span>

		<a class="button worklist-button" (click)="requestDirector('addToWorklist')"><i class="fa fa-paperclip"></i>
			<span>{{ (selectedRows.length ? 'ADD_TO_WORKLIST' : 'ADD_ALL_TO_WORKLIST') | translate }}</span>
		</a>

		<bb-cloning-info [selectedRows]="selectedRows" [hasPermission]="'cloning'"></bb-cloning-info>

		<div class="button-with-panel-container" (mouseover)="setPlaylistClosing(false)">
			<a (click)="togglePlaylistPanel()" class="button fast" [ngClass]="{'disabled': selectedRows.length < 1, 'active': playlistPanelOpen}"><i class="fa fa-list-ol"></i> {{ 'ADD_TO_PLAYLIST' | translate }}</a>
			<div class="add-to-playlist-panel" *ngIf="playlistPanelOpen" (mouseover)="setPlaylistClosing(false)" (mouseleave)="setPlaylistClosing(true)">
				<div class="close-panel" (click)="togglePlaylistPanel()"><i class="fa fa-close"></i></div>
				<playlist-select (hidePanel)="togglePlaylistPanel()" [selectedClips]="selectedRows"></playlist-select>
			</div>
		</div>

		<a class="button" [ngClass]="{'disabled': !selectedRows.length || !deleteRight}" (click)="requestDirector('delete')"><i class="fa fa-trash"></i>
			<span>{{ 'DELETE' | translate }}</span>
		</a>

		<a class="button"[ngClass]="{'disabled': !selectedRows.length || !putRight}" (click)="requestDirector('togglePublished')"><i class="fa fa-circle"></i>
			<span *ngIf="!hasDraftSelected">{{ 'UNPUBLISH' | translate }}</span>
			<span *ngIf="hasDraftSelected">{{ 'PUBLISH' | translate }}</span>
		</a>
	</div>

	<bb-table-container>

		<bb-table-header>
			<bb-table-header-cell class="thumb"></bb-table-header-cell>
			<bb-table-header-cell class="icon"></bb-table-header-cell>
			<bb-table-header-cell property="id">{{ 'ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="title">{{ 'TITLE' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="length">{{ 'LENGTH' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="views">{{ 'VIEWS' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="sourceid">{{ 'SOURCE_ID' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="status" class="icon" [ngClass]="{'status-and-stream-status': rowsContainLiveClips}">&nbsp;</bb-table-header-cell>
			<bb-table-header-cell property="createddate" class="date">{{ 'CREATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="createdBy">{{ 'CREATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell property="updateddate" class="date">{{ 'UPDATED' | translate }}</bb-table-header-cell>
			<bb-table-header-cell optional property="updatedBy">{{ 'UPDATED_BY' | translate }}</bb-table-header-cell>
			<bb-table-header-cell class="buttons"></bb-table-header-cell>
		</bb-table-header>

		<bb-table-row *ngFor="let row of rows" [row]="row">
			<bb-table-cell class="thumb">
				<div class="thumbnail-wrapper" [attr.title]="row?.transcodingAverage < 1? ('TRANSCODING_STATUS' | translate) + (row?.transcodingAverage > 0 ? (row?.transcodingAverage | percentage: 0) : 'queued') : ''">
					<span *ngIf="row?.transcodingAverage < 1" class="transcoding-progress">{{ row?.transcodingAverage | percentage: 0 }}</span>
					<div *ngIf="row?.transcodingAverage < 1" class="thumbnail-overlay"></div>

					<span [innerHTML]="row.data | thumbnail : 50:28:null:row?.transcodingAverage < 1 | async"></span>
				</div>
			</bb-table-cell>
			<bb-table-cell><span style="white-space: no-break;"><span [innerHTML]="row.data | clipIcon"></span><strong [hidden]="row.data.usetype !== 'commercial'" style="padding: 3px; color: #f8b32a;" title="Creative">C</strong></span></bb-table-cell>
			<bb-table-cell property="id">{{ row.data.id }}</bb-table-cell>
			<bb-table-cell property="title" class="overflow">
				<span [hidden]="!row.data.title">{{ row.data.title }}</span>
				<span [hidden]="row.data.title" class="filename">{{ row.data.originalfilename }}</span>
				
			</bb-table-cell>
			<bb-table-cell property="length">{{ row.data.length | seconds }}</bb-table-cell>
			<bb-table-cell property="views">{{ row.data.views | number }}</bb-table-cell>
			<bb-table-cell optional property="sourceid">{{ row.data.sourceid }}</bb-table-cell>
			<bb-table-cell property="status" *ngIf="row?.data?.sourceid?.startsWith('live_api_')" [ngClass]="{'status-and-stream-status': rowsContainLiveClips}"><span [innerHTML]="(row.data | statusIcon) + (row.data | bbStreamStatusIcon | async)" class="stream-status-icon"></span></bb-table-cell>
			<bb-table-cell property="status" *ngIf="!row?.data?.sourceid?.startsWith('live_api_')" [ngClass]="{'status-and-stream-status': rowsContainLiveClips}"><span [innerHTML]="row.data | statusIcon"></span></bb-table-cell>
			<bb-table-cell property="createddate" class="date" [titleValue]="row.data.createddate | bbDate">{{ row.data.createddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="createdBy" [titleValue]="row.data.createdBy">{{ row.data.createdBy }}</bb-table-cell>
			<bb-table-cell property="updateddate" class="date" [titleValue]="row.data.updateddate | bbDate">{{ row.data.updateddate | bbDate:'relative' }}</bb-table-cell>
			<bb-table-cell optional property="updatedBy" [titleValue]="row.data.updatedBy">{{ row.data.updatedBy }}</bb-table-cell>
			<bb-table-cell class="buttons">

				<a class="button" [routerLink]="['/library/mediaclip/', row.data.id, 'metadata']">
					<i class="fa fa-edit"></i>
				</a>
				<a class="button" (click)="showPreview(row.data)">
					<i class="fa fa-eye"></i>
				</a>
				<a class="button"
				data-cy="media-list-interactivity-button"
				[hasPermission]="'interactivity'"
				[class.disabled]="!row.data.timelines || !row.data.timelines[0]"
				[routerLink]="['/library/interactivity/', row.data.timelines && row.data.timelines[0]]">
					<i class="fa fa-object-group"></i>
				</a>
				<a class="button" [routerLink]="['/analytics/statistics/', row.data.id]">
					<i class="fa fa-line-chart"></i>
				</a>
				<a class="button" (click)="deleteSingle(row.data)">
					<i class="fa fa-trash"></i>
				</a>

				<ng-template #deleteTemplate>
					<div>
						<p>
							{{ relationInfo.defaultContents }}
						</p>
						<p class="loading-relations" *ngIf="relationInfo?.relations?.project?.length && !relationInfo?.projects?.length">
							{{ 'ENTITY_USED_IN_X_ENTITIES' | translate: {x: relationInfo?.relations?.project?.length, entities: ( (relationInfo?.relations?.project?.length === 1 ? 'PROJECT' : 'PROJECTS') | translate | lowercase )} }}
						</p>
						<p *ngIf="relationInfo?.projects?.length">
							{{ 'ENTITY_USED_IN_ENTITIES' | translate: {entities: ( 'PROJECTS' | translate | lowercase )} }}
						</p>
					</div>
					<ul class="project-list" *ngIf="relationInfo?.projects?.length">
						<li class="project" *ngFor="let project of relationInfo.projects">
							<a class="blue" [routerLink]="['/library/project/' + project.id]">
								{{ project.title }}
							</a>
						</li>
					</ul>
				</ng-template>			

			</bb-table-cell>
		</bb-table-row>

	</bb-table-container>

	<div class="no-results" *ngIf="rows && !rows.length">{{ 'NO_MEDIA_CLIPS_FOUND' | translate }}</div>

	<bb-table-pager></bb-table-pager>

</div>
